import React from "react";

function LaunchPlatformBanner() {
  return (
    <div className="cta-area position-relative overflow-hidden" style={{ background: "#0a0e14", padding: "80px 0" }}>
      {/* Decorative background circle */}
      <div className="position-absolute" style={{ width: "600px", height: "600px", background: "rgba(33, 150, 243, 0.05)", borderRadius: "50%", bottom: "-300px", right: "-300px" }}></div>
      
      <div className="container position-relative z-1">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-7 text-lg-start text-center">
            <h2 className="title fw-bold text-white mb-3" style={{ fontSize: "38px" }}>Ready to Launch Your DeFi Platform?</h2>
            <p className="text-white opacity-75 fs-5">Join the decentralization revolution with a partner that values security as much as you do.</p>
          </div>
          <div className="col-lg-4 text-lg-end text-center mt-4 mt-lg-0">
            <a href="#" className="btn btn-style-one px-5 py-3 fs-5 shadow-lg">
              Talk to our Experts <i className="fas fa-arrow-right ms-2"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LaunchPlatformBanner;
